export enum PROJECT_TRIGGERS {
  "ENABLE_BOTTLE_TAP",
  "FOUND_GEMS",
  "CONTROL_CLICKABLE",
  "ANIMATE_GEMS",
  "ANIMATE_GEMS_BAR",
}
